import { useMemo } from 'react';

import type { ShareActionsOptions } from 'src/app/shared/hooks/share';

import type { CommentShareChannel, PartialComment, PartialPetition, ShareConfig } from '../types';

import { useGetCommentShareContent } from './content';
import { useGetCommentShareTrackingData } from './tracking';
import { useGetCommentShareUrl } from './url';

export function useCommentShareOptions(
	comment: PartialComment,
	petition: PartialPetition,
	config: ShareConfig,
): ShareActionsOptions<CommentShareChannel> {
	const getUrl = useGetCommentShareUrl(comment, petition);
	const getContent = useGetCommentShareContent(comment);
	const getTrackingData = useGetCommentShareTrackingData(comment, petition, config);

	return useMemo(
		() => ({
			trackingEventName: 'comment_share',
			getUrl,
			getContent,
			getTrackingData,
		}),
		[getUrl, getContent, getTrackingData],
	);
}
